

































































import { Component, Vue } from "vue-property-decorator";
import { inject } from 'inversify-props';
import { passwordRules, required } from "@/utils/validation";
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';
import { IAuthService } from '@/interfaces/Services';

@Component({})
class ChangePasswordCard extends Vue {
  @inject(DependencyIdentifiers.AuthService)
  private authService!: IAuthService;

  private enabled = false;
  private formData = {
    currentPassword: "",
    newPassword: ""
  };

  private visibility = {
    currentPassword: false,
    newPassword: false,
    confirmNewPassword: false,
  };

  private get formConfig() {
    return {
      currentPassword: {
        label: this.$t("account.currentPassword"),
        rules: [required],
      },
      newPassword: {
        label: this.$t("account.newPassword"),
        rules: [required, ...passwordRules],
      },
      confirmNewPassword: {
        label: this.$t("account.newPasswordConfirm"),
        rules: [
          (v: string | undefined) =>
            (v === this.formData.newPassword) || this.$t("validator.password.confirmMismatch")
        ],
      }
    };
  }

  async mounted() {
    this.enabled = true;
    this.isLoading = false;
  }

  async submit() {
    // @ts-ignore
    if (!this.$refs.form.validate()) {
      return;
    }
    this.isLoading = true;
    try {
      await this.authService.changePassword(this.formData.currentPassword, this.formData.newPassword);
    } finally {
      this.isLoading = false;
    }
  }

  isLoading = false;

  get disabled() {
    return this.enabled === false;
  }

  set disabled(value: boolean) {
    this.enabled = value === false;
  }
}

export default ChangePasswordCard;
